module.exports = __webpack_public_path__ + "static/media/rackham05full.e48da8c9.jpg";